<template>
  <div>
    <el-row class="bg-color-w py-20 px-30">
      <el-row class="">
        <div class="float-l">
          <div class="float-l">{{ $t("xmsq.xsnr") }}：</div>
          <div class="float-l dy-flex">
            <ButtonBox
              :id="'wfzd'"
              :plain="activeBtn != '1'"
              :buttonData="getArgumentDetail('wfzdbtn')"
              @click.native="setActiveBtn('1')"
              :uniqueNum="uniqueNum"
              :icon="'el-icon-document'"
              class="ml-10"
            >
              <span>{{ "(" + tableTotal1 + "个)" }}</span></ButtonBox
            >
            <ButtonBox
              :id="'bsqd'"
              :plain="activeBtn != '2'"
              :buttonData="getArgumentDetail('bsqdbtn')"
              @click.native="setActiveBtn('2')"
              :uniqueNum="uniqueNum"
              :icon="'fa fa-sign-in'"
              class="ml-10"
            ></ButtonBox>
            <ButtonBox
              :id="'sqtrd'"
              :plain="activeBtn != '3'"
              :buttonData="getArgumentDetail('sqtrdbtn')"
              @click.native="setActiveBtn('3')"
              :uniqueNum="uniqueNum"
              :icon="'fa fa-sign-out'"
              class="ml-10"
            ></ButtonBox>
            <ButtonBox
              :id="'bsqr'"
              :plain="activeBtn != '4'"
              :buttonData="getArgumentDetail('bsqrbtn')"
              @click.native="setActiveBtn('4')"
              :uniqueNum="uniqueNum"
              :icon="'fa fa-users'"
              class="ml-10"
            ></ButtonBox>
          </div>
        </div>
      </el-row>
      <!-- 动态表格组件 -->
      <el-row class="mt-20">
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :uniqueNum="uniqueNum"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          :rowkey="'xzk'"
          :reserveSelection="true"
          :height="$store.state.screenHeight - 285"
          @handleClickFun="handleClickFun"
          @searchFilter="searchFilter"
        ></TableCommon>
      </el-row>
      <el-row>
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </el-row>
  </div>
</template>

<script>
import * as sqgl from "@/api/sqgl";
// import * as sqgl from "@/api/qhsqgl";

export default {
  // 我的项目
  name: "myProject",
  components: {},
  computed: {},
  data() {
    return {
      tabLoading: true,
      tableColumns: [],
      tableColumns1: [],
      tableColumns2: [],
      tableColumns3: [],
      tableColumns4: [],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      uniqueNum: "Y120110-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      bsqr: "",
      flg: "0",
      saveflg: "0",
      rydm: null,
      activeBtn: "1",
      params: {},
      tableTotal1: 0,
      tableTotal2: 0,
      tableTotal3: 0,
      tableTotal4: 0,
      argumentDetail: {},
      argumentConfig: {
        wfzdbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-wfzd",
        },
        bsqdbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-dsqd",
        },
        sqtrdbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-sqtrd",
        },
        bsqrbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-bsqr",
        },
      },
    };
  },
  methods: {
    setActiveBtn(active) {
      this.rydm = null;
      this.activeBtn = active;
      this.currentPage = 1;
      if (active == "1") {
        this.getMyProject();
        this.getPageTableConfig();
      } else if (active == "2") {
        this.getBsqInfo();
        this.getPageTableConfig2();
      } else if (active == "3") {
        this.getQxxmsq();
        this.getPageTableConfig3();
      } else if (active == "4") {
        this.getBsqrAndXmByFzr();
        this.getPageTableConfig4();
      }
    },
    //   获取当前用户项目授权
    getMyProject() {
      let params = {};
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      this.tableData = [];
      sqgl.getWfzdxm(params).then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          item.projectProperty == "1"
            ? (item.projectProperty = this.$t("xmsq.personal"))
            : item.projectProperty == "2"
            ? (item.projectProperty = this.$t("xmsq.public"))
            : "";
        });
        if (this.activeBtn == "1") {
          this.tableData = data;
          this.total = res.data.total;
        }
        this.tabLoading = false;
      });
    },
    //   获取当前用户被授权项目
    getBsqInfo() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      params.type = "xmsq";
      this.tableData = [];
      sqgl.getDisBsqInfo(params).then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          item.projectProperty == "1"
            ? (item.projectProperty = this.$t("xmsq.personal"))
            : item.projectProperty == "2"
            ? (item.projectProperty = this.$t("xmsq.public"))
            : "";
        });
        if (this.activeBtn == "2") {
          this.tableData = data;
          this.total = res.data.total;
        }
        this.tabLoading = false;
      });
    },
    //   获取当前用户授权他人项目
    getQxxmsq() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      // params.bsqr = this.rydm;
      this.tableData = [];
      sqgl.getDisQxxmsq(params).then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          item.projectProperty == "1"
            ? (item.projectProperty = this.$t("xmsq.personal"))
            : item.projectProperty == "2"
            ? (item.projectProperty = this.$t("xmsq.public"))
            : "";
        });
        if (this.activeBtn == "3") {
          this.tableData = data;
          this.total = res.data.total;
        }
        this.tabLoading = false;
      });
    },
    //   根据项目负责人查询被授权人和项目
    getBsqrAndXmByFzr() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      params.bsqr = this.rydm;
      this.tableData = [];
      this.total = 0;
      sqgl.getBsqrAndXmByFzr(params).then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          item.projectProperty == "1"
            ? (item.projectProperty = this.$t("xmsq.personal"))
            : item.projectProperty == "2"
            ? (item.projectProperty = this.$t("xmsq.public"))
            : "";
        });
        if (this.activeBtn == "4") {
          this.tableData = data;
          this.total = res.data.total;
        }
        this.tabLoading = false;
      });
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120110";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    getPageTableConfig2() {
      let params = {};
      params.pageId = "Y120110";
      params.moduleId = "1";
      params.groupId = "2";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    getPageTableConfig3() {
      let params = {};
      params.pageId = "Y120110";
      params.moduleId = "1";
      params.groupId = "3";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    getPageTableConfig4() {
      let params = {};
      params.pageId = "Y120110";
      params.moduleId = "1";
      params.groupId = "4";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      if (this.activeBtn == "1") {
        this.getMyProject();
      } else if (this.activeBtn == "2") {
        this.getBsqInfo();
      } else if (this.activeBtn == "3") {
        this.getQxxmsq();
      } else if (this.activeBtn == "4") {
        this.getBsqrAndXmByFzr();
      }
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.currentPage = 1;
      this.limit = val;
      if (this.activeBtn == "1") {
        this.getMyProject();
      } else if (this.activeBtn == "2") {
        this.getBsqInfo();
      } else if (this.activeBtn == "3") {
        this.getQxxmsq();
      } else if (this.activeBtn == "4") {
        this.getBsqrAndXmByFzr();
      }
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120110",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    // 点击按钮或链接
    handleClickFun(row) {
      if (row.oprationflg.en == "cancelProject") {
        this.qxxmsq(row.row);
      }
    },
    // 取消项目授权
    qxxmsq(row) {
      if (row.children && row.children.length > 0) {
        this.cancelProjects(row);
      } else {
        this.cancelProject(row);
      }
    },
    // 单个取消项目授权
    cancelProject(row) {
      this.$confirm(
        this.$t("xmsq.sfqx") +
          row.bmbh +
          "/" +
          row.xmbh +
          this.$t("xmsq.zgsqxm"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirmBtn"),
          cancelButtonText: this.$t("common.cancelBtn"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          sqgl.cancelProject(row).then((res) => {
            this.getBsqrAndXmByFzr();
            if (res.data.code == "200") {
              this.$message({
                message: res.data.data,
                type: "success",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("xmsq.Operationcancel"),
          });
        });
    },
    // 批量取消项目授权
    cancelProjects(row) {
      let arr = row.children;
      if (arr.length > 0) {
        this.$confirm(
          this.$t("xmsq.sfqx") + "【" + row.bsqr + "】" + this.$t("xmsq.syxm"),
          this.$t("common.tips"),
          {
            confirmButtonText: this.$t("common.confirmBtn"),
            cancelButtonText: this.$t("common.cancelBtn"),
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            sqgl.cancelProjects(arr).then((res) => {
              this.getBsqrAndXmByFzr();
              this.$message({
                message: res.data.data,
                type: "success",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("xmsq.Operationcancel"),
            });
          });
      } else {
        this.$message({
          message: this.$t("xmsq.Noselect"),
          type: "warning",
        });
      }
    },
    // 筛选被授权人
    searchFilter(search) {
      this.rydm = search;
      this.getBsqrAndXmByFzr();
    },
  },
  mounted() {
    this.params.yhbh = this.yhxx.ygbh;
    this.params.bsqr = this.rydm;
    this.loadQueryConfig();
    this.getPageTableConfig();
    this.getMyProject();
  },
};
</script>

<style lang="scss" scoped>
.btnActive {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
</style>
